import { type MutableRefObject, type RefObject, useEffect } from 'react';

type UseVisibilityChangeOptions = {
  onVisible: () => void;
  onHidden: () => void;
  ref?: RefObject<HTMLDivElement>;
  scrollRef?: MutableRefObject<number>;
};

export const useVisibilityChange = ({
  onVisible,
  onHidden,
  ref,
  scrollRef,
}: UseVisibilityChangeOptions) => {
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        onVisible();
        if (ref?.current && scrollRef) {
          ref.current.scrollTop = scrollRef.current;
        }
      } else {
        onHidden();
        if (ref?.current && scrollRef) {
          scrollRef.current = ref.current.scrollTop;
        }
      }
    };

    const handlePageHide = () => {
      onHidden();
      if (ref?.current && scrollRef) {
        scrollRef.current = ref.current.scrollTop;
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handlePageHide);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('pagehide', handlePageHide);
    };
  }, [onVisible, onHidden, ref, scrollRef]);
};
